export default __webpack_public_path__ + "static/media/i_ens.8cc79740.svg";